import angular from 'angular';
import 'angular-growl-v2';


export default class Growl {
    constructor (growl) {
        "ngInject";
        this.growl = growl;
    }

    deleted () {
        this.growl.success('Deleted sucessfuly !');
    }

    updated () {
        this.growl.success('Updated sucessfuly !');
    }

    added () {
        this.growl.success('Added sucessfuly !');
    }

    copied () {
        this.growl.success('Copied successfully !');
    }

    success (message) {
        this.growl.success(message);
    }

    error (message) {
        this.growl.error(message);
    }
}

angular.module('app.growl', ['angular-growl'])
    .service('$growl', Growl);



// WEBPACK FOOTER //
// ./src/app/services/growl.js